export const CLEAN = '@bonus/clean';
export const UPDATE = '@bonus/update';

export function update(values: any) {
  return async (dispatch: any) => {
    dispatch({
      type: UPDATE,
      payload: values
    });
  };
}

export function clean() {
  return async (dispatch: any) => {
    dispatch({
      type: CLEAN
    });
  };
}
